<!-- 中西会诊详情 -->
<template>
  <div class="tradiWrap">
    <div class="contain mainWrap">
      <div class="l">
        <div class="m_l_top">
          <el-select size="mini" v-model="changeJl" placeholder="请选择经络" @change="jlChange"
            style="width: 100%;margin-bottom: 9px;">
            <el-option v-for="item in jlOptions" :key="item.meridianName" :label="item.meridianNameDesc" :value="item.meridianName">
            </el-option>
          </el-select>
          <div class="cusBtn addBtn" @click="addNeedle">添加</div>
        </div>
        <div class="jluoOneW">
          <div class="jluoOne" v-for="(item, index) in jluoArr" :key="index">
          <div class="closeBtn" @click="delJl(index)"><i class="el-icon-close"></i></div>
          <div class="line">
            <span>时辰</span>
            <span>{{ item.time }}时</span>
          </div>
          <div class="line">
            <span>经络</span>
            <span>{{ item.jl.meridianNameDesc }}</span>
          </div>
          <div class="fiveBox">
            <div class="left">
              <div class="k">阳</div>
              <div class="miniCloseBtn" @click="clearYang(index)"><i class="el-icon-close"></i></div>
              <div class="x"></div>
              <div class="miniCloseBtn" @click="clearYin(index)"><i class="el-icon-close"></i></div>
              <div class="k">阴</div>
            </div>
            <div class="right">
              <div class="selectBox" v-show="showSelect && jlClickId == index">
                <div class="selectBtn" v-for="(item, index) in typeArr" :key="index" @click="doSelect(item)">{{ item.name }}
                </div>
              </div>
              <div class="one" v-for="(item2, index2) in item.fiveArr" :key="index2">
                <div class="k" @click="openSelect(index,index2,1)">{{ item2.name }}</div>
                <div class="type">
                  <i v-if="item2.needle1 !== null&&item2.needle1===0" class="el-icon-top"></i>
                  <i v-if="item2.needle1 !== null&&item2.needle1===1" class="el-icon-minus"></i>
                  <i v-if="item2.needle1 !== null&&item2.needle1===2" class="el-icon-bottom"></i>
                </div>
                <div class="x">{{ item2.xw }}</div>
                <div class="type">
                  <i v-if="item2.needle2 !== null&&item2.needle2===0" class="el-icon-top"></i>
                  <i v-if="item2.needle2 !== null&&item2.needle2===1" class="el-icon-minus"></i>
                  <i v-if="item2.needle2 !== null&&item2.needle2===2" class="el-icon-bottom"></i>
                </div>
                <div class="k" @click="openSelect(index,index2,0)">{{ item2.name }}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
        
      </div>
      <div class="r">
        <div class="r-t">
          <div class="r-t-l">医师姓名：{{userInfo.realName}}</div>
          <div class="r-t-r">{{  currentTime  }}</div>
        </div>
        <div class="r-box">
          <div class="box1">
            <div class="box1-t">
              <div class="t-box">
                <div class="tit">中医诊断</div>
                <div class="input-w">
                  <i class="el-icon-edit"></i>
                  <el-input type="textarea" :rows="5" :input-style="{ resize: 'none' }" v-model="form.diagnosisChinese"></el-input>
                </div>
              </div>
              <div class="t-box">
                <div class="tit">治疗方案</div>
                <div class="input-w">
                  <i class="el-icon-edit"></i>
                  <el-input type="textarea" :rows="5" :input-style="{ resize: 'none' }" v-model="form.treatmentPlan"></el-input>
                </div>
              </div>
              <div class="t-box">
                <div class="tit">西医诊断</div>
                <div class="input-w">
                  <i class="el-icon-edit"></i>
                  <el-input type="textarea" :rows="5" :input-style="{ resize: 'none' }" v-model="form.diagnosisWestern"></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="box2">
            <div class="title1">
              <div>仪器及化验</div>
              <div class="btn" @click="addFileItem()">
                <div class="btn-l">
                  <i class="el-icon-plus"></i>
                </div>
                <div class="btn-r">添加</div>
              </div>
            </div>
            <div class="box2-row" v-for="(item, index) in medicalExamineList" :key="index">
              <div class="row-l">
                <div class="row1">
                  <el-select size="mini" v-model="item.examine" placeholder="选择检查项">
                    <el-option v-for="item in examineList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="row2">
                  <el-select size="mini" v-model="item.department" placeholder="选择科室">
                    <el-option v-for="item in departmentList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="row2">
                  <el-select size="mini" v-model="item.part" placeholder="选择部位">
                    <el-option v-for="item in partList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="row3">
                   <el-upload
                      class="upload-demo"
                      :action="myFileUrl+'minio/upload'"
                      :data="{ itemId: item.id }"
                      :show-file-list="false"
                      :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, index)"
                      :before-upload="(file) => beforeUpload(file, index)"
                      multiple
                      :limit="3"
                      :file-list="item.pathList"
                      :on-exceed="(files, fileList) => handleExceed(files, fileList, index)"
                    >
                      <el-button class="up" size="small" type="primary"><i
                                      class="el-icon-upload el-icon--right"></i>点击上传</el-button>
                    <!-- 自定义文件列表 -->
                    <div class="custom-upload-list" v-if="item.pathList.length > 0">
                      <div class="custom-file-item" v-for="(file, index2) in item.pathList" :key="file.uid">
                        <div class="fileWrap">
                          <div class="closeBtn"  @click.stop="handleRemove(file,index,index2)">
                            <i class="el-icon-circle-close"></i>
                          </div>
                          <div class="imgs">
                            <!-- <img :src="file.url" alt=""> -->
                              <img v-if="isImage(file.url)" :src="file.url" alt="">
                              <!-- <img v-else :src="defaultFileIcon" alt=""> -->
                                <i v-else class="el-icon-document"></i>
                          </div>
                        </div>
                      </div>
                      </div>     
                    </el-upload>
                </div>
              </div>
              <div class="row-r">
                <div class="date-w">
                  <el-date-picker
                    v-model="item.shotDate"
                    type="datetime"
                    size="mini"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </div>
                <div class="delBtn" @click="delFileItem(index)">
                  <i class="el-icon-delete"></i>
                  删除
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="r-box">
          <div class="top-btns">
            <div class="left-btn" :class="hands==1?'active':''" @click="hands=1">左手脉图</div>
            <div class="left-btn left-btn2":class="hands==2?'active':''"  @click="hands=2">右手脉图</div>
            <div class="line-line"></div>
           <div class="right-btn1" @click="requestDevice">连接脉象仪</div> 
              <div class="right-btn2">断开脉象仪</div> 
            <!-- <button @click="checkBluetooth">检查蓝牙状态</button>
            <button @click="requestDevice" :disabled="!bluetoothEnabled">连接蓝牙设备</button> -->

            <!-- <div v-if="bluetoothStatus === 'checking'">正在检查蓝牙状态...</div>
            <div v-else-if="bluetoothStatus === 'enabled'">蓝牙已启用</div>
            <div v-else-if="bluetoothStatus === 'disabled'">蓝牙未启用或不可用</div>
            <div v-else-if="bluetoothStatus === 'unsupported'">浏览器不支持蓝牙</div>

            <div v-if="device">
              <p>已连接设备: {{ device.name }}</p>
              <button @click="getServiceId">获取设备服务</button>
            </div>

            <div v-if="services.length > 0">
              <h3>设备服务列表:</h3>
              <ul>
                <li v-for="service in services" :key="service.uuid">
                  {{ service.uuid }}
                  <button @click="getCharacteristics(service)">获取特征值</button>
                </li>
              </ul>
            </div>

            <div v-if="error" class="error">错误: {{ error }}</div> -->
          </div>
          <div class="r-box-content" v-show="hands==1">
            <div class="content-top">
              <div class="lamp">
                <div class="pulse-container">
                  <!-- 核心扩散元素 -->
                  <div class="pulse-circle"></div>
                </div>
                <div>点击获取左手脉象</div>
              </div>
              <div class="num">
                <div class="num1">脉象数</div>
                <div class="num2">
                  <el-input size="mini"></el-input>
                </div>
                <div class="num3">次/分钟</div>
              </div>
            </div>
            <div class="title2">轻压</div>
            <div class="chartWrap">
              <div class="chartBox">
                <div class="chartTop">
                  <div>寸</div>
                  <div>小肠</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts1" style="width:100%;height:128px"></div>
              </div>
              <div class="chartBox">
                <div class="chartTop">
                  <div>关</div>
                  <div>胆</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts2" style="width:100%;height:128px"></div>
              </div>
              <div class="chartBox">
                <div class="chartTop">
                  <div>尺</div>
                  <div>膀胱</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts3" style="width:100%;height:128px"></div>
              </div>
            </div>
            <div class="title2">重压</div>
            <div class="chartWrap">
              <div class="chartBox">
                <div class="chartTop">
                  <div>寸</div>
                  <div>心</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts4" style="width:100%;height:128px"></div>
              </div>
              <div class="chartBox">
                <div class="chartTop">
                  <div>关</div>
                  <div>肝</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts5" style="width:100%;height:128px"></div>
              </div>
              <div class="chartBox">
                <div class="chartTop">
                  <div>尺</div>
                  <div>肾</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts6" style="width:100%;height:128px"></div>
              </div>
            </div>
          </div>
          <div class="r-box-content" v-show="hands==2">
            <div class="content-top">
              <div class="lamp">
                <div class="pulse-container">
                  <!-- 核心扩散元素 -->
                  <div class="pulse-circle"></div>
                </div>
                <div>点击获取右手脉象</div>
              </div>
              <div class="num">
                <div class="num1">脉象数</div>
                <div class="num2">
                  <el-input size="mini"></el-input>
                </div>
                <div class="num3">次/分钟</div>
              </div>
            </div>
             <div class="title2">轻压</div>
            <div class="chartWrap">
              <div class="chartBox">
                <div class="chartTop">
                  <div>寸</div>
                  <div>大肠</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts11" style="width:100%;height:128px"></div>
              </div>
              <div class="chartBox">
                <div class="chartTop">
                  <div>关</div>
                  <div>胃</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts21" style="width:100%;height:128px"></div>
              </div>
              <div class="chartBox">
                <div class="chartTop">
                  <div>尺</div>
                  <div>三焦</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts31" style="width:100%;height:128px"></div>
              </div>
            </div>
             <div class="title2">重压</div>
            <div class="chartWrap">
              <div class="chartBox">
                <div class="chartTop">
                  <div>寸</div>
                  <div>肺</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts41" style="width:100%;height:128px"></div>
              </div>
              <div class="chartBox">
                <div class="chartTop">
                  <div>关</div>
                  <div>脾</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts51" style="width:100%;height:128px"></div>
              </div>
              <div class="chartBox">
                <div class="chartTop">
                  <div>尺</div>
                  <div>心泡</div>
                  <div>脉象</div>
                </div>
                <div ref="echarts61" style="width:100%;height:128px"></div>
              </div>
            </div>
          </div>
          <div class="r-btm">
            <div class="r-btm-btn r-btm-btn2" @click="cancels">取消</div>
            <div class="r-btm-btn" @click="submit">保存</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { MessageBox } from 'element-ui';
export default {
  name: "tradiInfo",
  data() {
    return {
      showSelect: false,
      hands:1,
      jluoArr: [],
      jlOptions: [],
      typeArr: [{
        name: '补针',
        type: 0
      },
      {
        name: '直刺',
        type: 1
      },
      {
        name: '泄针',
        type: 2
      },
      {
        name: '取消',
        type: null
      }
      ],
      form: {
        diagnosisChinese:'',//中医诊断
        diagnosisWestern:'',//西医诊断
        treatmentPlan: '',//治疗方案
      },
      medicalExamineList:[
          {
            department:'',//科室department
            examine:'',//检查项examine
            part:'',
            shotDate:'',//拍摄时间
            pathList:[]
          }
        ],
      fileList: [],
      value: '',
      options: [],
       pickerOptions: {
          disabledDate(time) {
             return time.getTime() > Date.now();
          }
        },
      data: [10, 200, 30, 200, 100, 10, 100, 30, 300, 200,
      10, 200, 30, 200, 100, 10, 100, 30, 300, 200,
      10, 200, 30, 200, 100, 10, 100, 30, 300, 200,
      10, 200, 30, 200, 100, 10, 100, 30, 300, 200,
      10, 200, 30, 200, 100, 10, 100, 30, 300, 200,
      10, 200, 30, 200, 100, 10, 100, 30, 300, 200,
      10, 200, 30, 200, 100, 10, 100, 30, 300, 200,
      10, 200, 30, 200, 100, 10, 100, 30, 300, 200
    ], //数据对象
    userInfo:{},
      bluetoothEnabled: false,
      bluetoothStatus: '',
      device: null,
      server: null,
      services: [],
      targetServiceId: null,
      error: null,
      // 你需要的特定服务UUID
      targetServiceUUIDs: [
        '0000fff0-0000-1000-8000-00805f9b34fb', // 注意Web Bluetooth要求小写
        '00001000-0000-1000-8000-00805f9b34fb'
      ],
      changeJl:null,//记录经络值
      indexP : null,//indexP 父级索引
      indexC :null,//indexC子集索引
      type :null,//0阴1阳
        currentTime: '', // 用于存储格式化后的时间
        jlClickId:''

    }
  },
   computed: {
    formattedTime() {
      const date = this.currentTime;
      const year = date.getFullYear();
      const month = this.padZero(date.getMonth() + 1);
      const day = this.padZero(date.getDate());
      const hours = this.padZero(date.getHours());
      const minutes = this.padZero(date.getMinutes());
      const seconds = this.padZero(date.getSeconds());
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDate() {
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      const date = this.currentTime;
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${weekdays[date.getDay()]}`;
    }
  },
  watch: {

  },
  mounted() {
    let myChart = echarts.init(this.$refs.echarts1) //绑定DOM
    let option = {
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value',
        min: 1
      },
      grid: {
        left: '13%',
        right: '4%',
        bottom: '3%',
        top: '15%',
        containLabel: false
      },
      series: [{
        name: 'Sales',
        type: 'line',
        smooth: true,
        color: '#55D2BC',
        data: this.data //数据绑定
      }]
    }
    myChart.setOption(option);
    // 监听蓝牙状态变化（部分浏览器支持）
    if (navigator.bluetooth && navigator.bluetooth.addEventListener) {
      navigator.bluetooth.addEventListener('availabilitychanged', (event) => {
        this.bluetoothEnabled = event.value;
        this.bluetoothStatus = event.value ? 'enabled' : 'disabled';
      });
    }
    this.checkBluetooth();

    // 从本地存储加载之前的目标服务ID
    const savedServiceId = localStorage.getItem('targetServiceId');
    if (savedServiceId) {
      this.targetServiceId = savedServiceId;
    }
    // 初始化显示当前时间
    this.updateTime2()
    // 每秒更新一次时间
    this.timer = setInterval(this.updateTime2, 1000)
  },
  created() {
     if (sessionStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
    this.getJLList();
    this.dataDictionary('department')
    this.dataDictionary('examine')
    this.dataDictionary('part')
     
  },
  methods: {
     isImage(url) {
      if (!url) return false;
      // 常见的图片扩展名
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
      return imageExtensions.some(ext => url.toLowerCase().endsWith(ext));
    },
    getJLList() {
      let that = this;
      let params = {
      };
      let url = "medicalMeridian/findList";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            this.jlOptions = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    getJLdDetail(value) {
      let that = this;
      let params = {
        meridianName:value
      };
      let url = "medicalMeridian/getByMeridian";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            let data = res.data;
            data.jl = this.jlOptions[value-1];
            data.fiveArr= [{
                name: '金',
                xw: data.gold,
                needle1:null,
                needle2:null
              }, {
                name: '木',
                xw: data.wood,
                needle1:null,
                needle2:null
              }, {
                name: '水',
                xw: data.water,
                needle1:null,
                needle2:null
              }, {
                name: '火',
                xw: data.fire,
                needle1:null,
                needle2:null
              }, {
                name: '土',
                xw: data.soil,
                needle1:null,
                needle2:null
              }];
            let jluoArr = this.jluoArr;
                jluoArr.push(res.data);
            jluoArr.sort((a, b) => a.id - b.id);
            this.jluoArr= jluoArr;
             this.changeJl = null;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    delJl(index){
     MessageBox.alert('是否要删除该经络', '删除', {
          confirmButtonText: '确定',
          type: 'info'
        }).then(() => {
          this.jluoArr.splice(index, 1);
          this.changeJl = null;
        });
    },
    jlChange(e){
       this.changeJl = e;
    },
    addNeedle(){
      if(this.changeJl){
        console.log(this.changeJl)
        const found = this.jluoArr.some(item => item.id === this.changeJl+'');
        if (found){
          this.$message('该经络已添加');
          return; // 找到则跳出方法
        } 
          this.getJLdDetail(this.changeJl)
         
      }else{
        this.$message('请先选择经络');
      }
    },
    clearYang(index){
      this.jluoArr[index].fiveArr.forEach(item => {
        item.needle1 = null;
      });
    },
     clearYin(index){
      this.jluoArr[index].fiveArr.forEach(item => {
        item.needle2 = null;
      });
     },
    handleCommand(e, index) {
      console.log(index)
    },
    openSelect(indexP,indexC,type) {
      // type 0阴1阳; indexP 父级索引 ;indexC子集索引
      this.jlClickId = indexP;
      this.indexP = indexP;
      this.indexC = indexC;
      this.type = type;
      this.showSelect = true;
    },
    doSelect(item) {
      let indexP =this.indexP;
      let indexC =this.indexC;
      let type =this.type;
      if(type ==1){
        this.jluoArr[indexP].fiveArr[indexC].needle1 = item.type;
      }else{
        this.jluoArr[indexP].fiveArr[indexC].needle2 = item.type;
      }
      this.showSelect = false;
    },
    addFileItem(){
      let obj =  {
            department:'',//科室department
            examine:'',//检查项examine
            shotDate:'',//拍摄时间
            pathList:[]
          };
       this.medicalExamineList.push(obj)
       console.log(this.medicalExamineList) 
    },
    delFileItem(index){
      this.medicalExamineList.splice(index,1)
    },
// 经络穴位数据转换
transformData(data) {
  const medicalMeridianRecordList = [];
  data.forEach(item => {
    const obj = {
      meridian:item.jl.meridianName,
      yangFire: null,
      yangGold: null,
      yangSoil: null,
      yangWater: null,
      yangWood: null,
      yinFire: null,
      yinGold: null,
      yinSoil: null,
      yinWater: null,
      yinWood: null
    };
    
    item.fiveArr.forEach(element => {
      // 根据五行名称映射到对应的属性
      switch(element.name) {
        case '金':
          obj.yangGold = element.needle1;
          obj.yinGold = element.needle2;
          break;
        case '木':
          obj.yangWood = element.needle1;
          obj.yinWood = element.needle2;
          break;
        case '水':
          obj.yangWater = element.needle1;
          obj.yinWater = element.needle2;
          break;
        case '火':
          obj.yangFire = element.needle1;
          obj.yinFire = element.needle2;
          break;
        case '土':
          obj.yangSoil = element.needle1;
          obj.yinSoil = element.needle2;
          break;
      }
    });
    
    medicalMeridianRecordList.push(obj);
  });
  
  return medicalMeridianRecordList;
},
// 过滤经络穴位无效数据的方法
filterValidRecords(data) {
  return data.filter(record => {
    // 检查除meridian外的所有字段是否都为null/undefined
    const { meridian, ...otherFields } = record;
    
    return Object.values(otherFields).some(
      value => value !== null && value !== undefined
    );
  });
},
checkDataIntegrity(data) {
  return data.map(item => {
    // 明确需要校验的核心字段（去掉 path，只关注实际必要的字段）
    const requiredFields = [
      'department',  // 科室
      'examine',     // 检查项目
      'shotDate',    // 拍摄日期
      'pathList'     // 附件列表
    ];

    // 检查每个核心字段是否有有效值
    const validFields = requiredFields.filter(field => {
      if (field === 'pathList') {
        // 特殊处理 pathList：必须是数组且至少有一个文件
        return Array.isArray(item[field]) && item[field].length > 0;
      } else {
        // 其他字段：非空（排除空字符串、null、undefined）
        return item[field] !== '' && item[field] !== null && item[field] !== undefined;
      }
    });

    // 判定完整性状态
    let isValid;
    if (validFields.length === 0) {
      // 所有核心字段都为空
      isValid = 'empty';
    } else if (validFields.length === requiredFields.length) {
      // 所有核心字段都有有效值
      isValid = 'complete';
    } else {
      // 部分核心字段有值，部分为空
      isValid = 'partial';
    }

    return {
      ...item,
      isValid
    };
  });
},

    //保存按钮
    submit(){
       let medicalMeridianRecordList = [];//经络穴位数据
       let validRecords =[];//过滤经络穴位里未录入数据，后的数据
       if(this.jluoArr.length){
           medicalMeridianRecordList = this.transformData(this.jluoArr);//经络穴位
           validRecords = this.filterValidRecords(medicalMeridianRecordList);
       }
     let validatedData = this.checkDataIntegrity(this.medicalExamineList);
      // 检查是否有部分填写的数据
      const partialItems = validatedData.filter(item => item.isValid === 'partial');
      if (partialItems.length > 0) {
        this.$message.warning('您的“西医仪器及化验”模块有部分信息未填写完整，请补全完整信息');
        return
      }
      const partialItems2 = validatedData.filter(item => item.isValid === 'complete');
      let medicalExamineList = partialItems2;
        const processedData = medicalExamineList.map(item => {
          // 从 pathList 中提取所有 bpath 值
          const bpaths = item.pathList.map(file => file.bpath);
          // 用逗号拼接 bpaths 并赋值给 path
          return {
            ...item,
            path: bpaths.join(',')
          };
        });
        if(!(
              validRecords.length
              ||this.form.diagnosisChinese
              ||this.form.diagnosisWestern
              ||this.form.treatmentPlan
              ||this.pulseCondition
              ||partialItems2.length > 0
            )
          ){
              this.$message.warning("您还没有填入数据");
              return 
          }
       let params = {
        ...this.form,
        medicalExamineList:processedData,
        medicalId:this.$route.query.id?this.$route.query.id:'',//医案id
        medicalMeridianRecordList:validRecords,
        pulseCondition:'',//脉象数据
      };
      let url = "medicakRecord/saveMedicalRecord";
      // console.log(params)
      this.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
           this.$message.success(res.msg);
            this.$router.push({
              path: "/tradiIndex"
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    cancels(){
      // window.history.go(-1);
      this.$router.go(-1);
    },
    //上传
       // 文件上传前的校验
    beforeUpload(file) {
      // 允许的文件 MIME 类型列表
      const allowedTypes = [
        'application/pdf',                        
        'image/jpeg', 'image/png','image/jpg',               
        'application/msword',                     
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
         
      ];
  // 'application/vnd.ms-excel',                
        // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'  
      // 校验文件类型
      const isTypeValid = allowedTypes.includes(file.type);
      // 校验文件大小（10MB）
      const isSizeValid = file.size / 1024 / 1024 <= 10;

      if (!isTypeValid) {
        this.$message.error('仅支持 PDF、图片、Word 文件');
        return false;
      }
      if (!isSizeValid) {
        this.$message.error('文件大小不能超过 10MB！');
        return false;
      }
      return true; // 通过校验
    },
    
    // 上传成功回调
    handleSuccess(response, file, fileList, index) {
       // 检查响应是否包含文件URL
      //  console.log(response,'123')
      if (response.data && response.data.url) {
        // 创建符合 el-upload 格式的文件对象
        const newFile = {
          name: file.name,           // 文件名
          bpath: response.data.bpath,         // 文件URL
           url: response.data.url,         // 文件URL
          status: 'success',         // 状态必须为 'success'
          uid: file.uid || Date.now() // 唯一标识
        };
        
        // 更新对应的 pathList
        this.$set(this.medicalExamineList[index], 'pathList', [
          ...this.medicalExamineList[index].pathList,
          newFile
        ]);
        console.log(`第${index}个组件上传成功`, response.data);
      // 处理对应组件的上传成功逻辑
      }else {
        this.$message.error('上传失败，服务器未返回URL');
      }
      
    },
    
    // 文件超出限制回调
    handleExceed(files, fileList, index) {
      this.$message.warning(`一条最多上传3个文件，如有需要请添加一条新的数据继续录入`);
    },
    
    // 手动触发上传示例
    triggerUpload(index) {
      this.$refs[`uploadRef${index}`].submit();
    },
    handleRemove(file, index,index2) {
       // 更新对应的 pathList
       this.medicalExamineList[index].pathList.splice(index2, 1);
        console.log(this.medicalExamineList);
      },
      handlePreview(file) {
        console.log(file);
      },





    //蓝牙设备
    // 检查蓝牙是否可用
    async checkBluetooth() {
      this.bluetoothStatus = 'checking';

      // 1. 检查浏览器是否支持
      if (!navigator.bluetooth) {
        this.bluetoothStatus = 'unsupported';
        this.bluetoothEnabled = false;
        return;
      }

      try {
        // 2. 尝试请求设备（不显示UI）
        const available = await navigator.bluetooth.getAvailability();

        if (available) {
          this.bluetoothStatus = 'enabled';
          this.bluetoothEnabled = true;
        } else {
          // 3. 如果getAvailability不支持，使用备用方法
          try {
            await navigator.bluetooth.requestDevice({
              filters: [{ name: '非存在设备-仅用于检测' }],
              optionalServices: ['generic_access']
            });
          } catch (error) {
            if (error.name === 'NotFoundError') {
              this.bluetoothStatus = 'enabled'; // 蓝牙已开启但没找到设备
              this.bluetoothEnabled = true;
            } else if (error.name === 'SecurityError') {
              this.bluetoothStatus = 'enabled'; // 有权限错误说明蓝牙可用
              this.bluetoothEnabled = true;
            } else {
              throw error;
            }
          }
        }
      } catch (error) {
        if (error.name === 'NetworkError') {
          this.bluetoothStatus = 'disabled';
          this.bluetoothEnabled = false;
          this.error = '蓝牙未开启或不可用';
        } else {
          this.bluetoothStatus = 'disabled';
          this.bluetoothEnabled = false;
          this.error = `蓝牙检测失败: ${error.message}`;
        }
      }
    },
    // 请求蓝牙设备
    async requestDevice() {
      try {
        this.error = null;
        this.device = await navigator.bluetooth.requestDevice({
          acceptAllDevices: true,
          optionalServices: ['generic_access']
        });

        this.server = await this.device.gatt.connect();
        console.log('蓝牙连接成功');
        // 监听断开事件
        this.device.addEventListener('gattserverdisconnected', this.onDisconnected);

      } catch (error) {
        if (error.name === 'NotFoundError') {
          this.error = '未找到蓝牙设备';
        } else {
          this.error = `连接失败: ${error.message}`;
        }
        console.error('蓝牙错误:', error);
      }
    },

 // 获取蓝牙设备所有服务（浏览器版本）
async getServiceId() {
  try {
    if (!this.device || !this.device.gatt.connected) {
      throw new Error('未连接到蓝牙设备');
    }
    
    // 浏览器获取服务的方式
    const server = await this.device.gatt.connect();
    const services = await server.getPrimaryServices();
    console.log('获取到的服务列表:', services);

    // 查找目标服务（与uni-app相同的UUID逻辑）
    const targetService = services.find(service => {
      const uuid = service.uuid.toLowerCase();
      return uuid === '0000fff0-0000-1000-8000-00805f9b34fb' || 
             uuid === '00001000-0000-1000-8000-00805f9b34fb';
    });

    if (targetService) {
      console.log('找到目标服务:', targetService.uuid);
      localStorage.setItem('serviceId', targetService.uuid);
      this.serviceId = targetService.uuid;
      
      // 这里可以继续获取特征值
      // await this.getCharacteristics(targetService);
    } else {
      console.warn('未找到目标服务');
    }
  } catch (err) {
    console.error("获取服务失败", err);
    // 可以添加错误处理逻辑，如重试或提示用户
  }
},
    // 获取服务的特征值（扩展功能）
    async getCharacteristics(service) {
      try {
        const characteristics = await service.getCharacteristics();
        console.log(`服务 ${service.uuid} 的特征值:`, characteristics);

        // 这里可以添加处理特定特征值的逻辑
        // 例如订阅通知或读写特征值

      } catch (error) {
        this.handleBluetoothError(error);
      }
    },

    // 错误处理
    handleBluetoothError(error) {
      if (error.name === 'NotFoundError') {
        this.error = '未找到蓝牙设备或服务';
      } else if (error.name === 'NetworkError') {
        this.error = '蓝牙连接已断开';
        this.onDisconnected();
      } else {
        this.error = `蓝牙操作失败: ${error.message}`;
      }
      console.error('蓝牙错误:', error);
    },

    onDisconnected() {
      console.log('设备已断开');
      this.device = null;
      this.server = null;
      this.services = [];
      this.targetServiceId = null;
    },
    //时间
   // 格式化时间为 YYYY-MM-DD HH:MM:SS
    formatTime2(date) {
      const year = date.getFullYear()
      const month = this.padZero(date.getMonth() + 1) // 月份从0开始，需+1
      const day = this.padZero(date.getDate())
      const hours = this.padZero(date.getHours())
      const minutes = this.padZero(date.getMinutes())
      const seconds = this.padZero(date.getSeconds())
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 补零函数（确保个位数时间显示为两位数）
    padZero(num) {
      return num < 10 ? '0' + num : num
    },
    // 更新时间
    updateTime2() {
      const now = new Date()
      this.currentTime = this.formatTime2(now)
    }
  },

  beforeDestroy() {
    clearInterval(this.timer); // 组件销毁前清除定时器
  }

};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 13px;
}

.el-select-dropdown__item {
  padding: 0 20px;
}

.fiveBox {
  display: flex;
  text-align: center;
}

.fiveBox .x {
  width: 23px;
  height: 61px;
  background: #F3F8FC;
  color: #333333;
}

.fiveBox .left .x {
  width: 23px;
  height: 73px;
  background: none;
}

.fiveBox .k {
  width: 23px;
  height: 23px;
  line-height: 23px;
  background: #DDDDDD;
  border-radius: 2px;
  font-size: 12px;
  color: #333333;
  text-align: center;
  cursor: pointer;
  margin: 2px 0;

}

.fiveBox .left .k:first-child {
  background: #F66248;
  color: #FFFFFF;
}

.fiveBox .left .k:last-child {
  background: #acacac;
  color: #FFFFFF;
}

.fiveBox .right {
  display: flex;
  position: relative;
}

.selectBox {
  position: absolute;
  width: 74px;
  background-color: #FFFFFF;
  top: 25px;
  left: 26px;
}

.selectBtn {
  border: 1px solid #F66248;
  cursor: pointer;
  border-radius: 5px;
  margin: 1px 0;
}
.fiveBox{
  padding-left: 5px;
}
.fiveBox .right .one {
  margin-left: 2px;
}

.fiveBox .right .one .type {
  color: #999;
  height: 24px;
  line-height: 24px;
}

.mainWrap {
  display: flex;

}

.mainWrap .l {
  width: 220px;
  min-height: calc(100vh - 530px);
  margin-right: 10px;
  position: relative;
}

.m_l_top {
  padding: 7px 8px;
  background: #FFFFFF;
  border-radius: 7px;
  margin-bottom: 16px;
}
.jluoOneW{
  height: 690px;
  width: 200px;
  overflow-y: auto;
   position: absolute;
   left:14px;
   top:80px;
}
.jluoOne {
  width: 180px;
  padding: 12px 8px;
  background: rgba(229, 232, 237, 0.72);
  border-radius: 7px;
  position: relative;
  margin-top: 15px;
}

.jluoOne .closeBtn {
  position: absolute;
  width: 18px;
  height: 18px;
  line-height: 18px;
  display: inline-block;
  background-color: #9A9A9A;
  color: #FFFFFF;
  border-radius: 50%;
  text-align: center;
  top: -8px;
  right: -8px;
  cursor: pointer;
  i{
    margin-left: 1px;
    margin-top: 3px;
  }

}

.miniCloseBtn {
  width: 14px;
  height: 14px;
  line-height: 14px;
  display: inline-block;
  background-color: #9A9A9A;
  color: #FFFFFF;
  border-radius: 50%;
  text-align: center;
  font-size: 10px;
  i{
    margin-top: 1px;
  }
}

.jluoOne .line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
}

.jluoOne .line span:first-child {
  font-size: 12px;
}

.jluoOne .line span:last-child {
  width: 115px;
  height: 25px;
  line-height: 25px;
  background: #F8F8F8;
  border-radius: 2px;
  border: 1px dashed #DDDDDD;
  display: inline-block;
  padding-left: 7px;
  color: #666666;
}

.mainWrap .r {
  width: 922px;
  min-height: calc(100vh - 530px);
}


.tradiWrap {
  background-color: #F3F6FB;
  padding-top: 10px;
  box-sizing: border-box;
  padding-bottom: 17px;
}


/* .contain {
  margin: 0 auto;
} */
 .contain {
  margin: 0 auto;
  width: 1124px!important;
}

.cusBtn {
  width: 100%;
  height: 25px;
  line-height: 25px;
  border-radius: 2px;
  background: #F66248;
  color: #FFFFFF;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
}

.addBtn:before {
  content: '+';
  display: inline-block;
  width: 13px;
  height: 12px;
  line-height: 12px;
  font-size: 16px;
  border: 1px solid #FFFFFF;
  margin-right: 6px;
}

.r-t {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  padding: 0 10px;

  div {
    float: left;
  }

  .r-t-r {
    margin-left: 60px;
    color: #999999;
  }
}

.box1 {
  border-bottom: 1px dashed #eee;
  padding-bottom: 10px;
}

.r-box {
  background-color: #fff;
  padding: 10px 16px;
  margin-top: 10px;

}

.box1-t {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.t-box {
  width: 32.5%;
}

.t-box .tit {
  height: 30px;
  line-height: 25px;
  font-weight: 600;
}

.input-w {
  width: 100%;
  height: 100%;
  position: relative;
}

.el-icon-edit {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 9;
}

>>>.el-textarea__inner {
  background-color: #F8F9FA;
  border: 1px solid #eee;
}

.box2 {
  width: 100%;
  margin-top: 10px;
}

.title1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.btn {
  width: 90px;
  padding: 10rpx;
  background-color: #F66248;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
}

.btn-l {
  width: 17px;
  height: 16px;
  text-align: center;
  line-height: 14px;
  border: 1px solid #fff;
  margin-right: 8px;

  i {
    font-size: 11px;
  }
}

.box2-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #F8F9FA;
  border: 1px dashed #E5E8ED;
  padding: 10px;
  margin-top: 5px;
}

.row-l {
  display: flex;
  align-items: center;
}

.row1,
.row2 {
  margin-right: 10px;
  width: 110px;
}

.row3 .el-button--primary {
  width: 90px;
  height: 30px;
  background-color: #fff;
  color: #999;
  border: 1px solid #DCDFE6;

  i {
    margin-right: 5px;
  }
}

.row-r {
    /* width: 129px; */
    display: flex;
    align-items: center;
}
.date-w{
  width: 110px;
  margin-right: 10px;
}
.date-w >>>.el-date-editor{
width: 100%;
}
.date-w .el-input--suffix >>>.el-input__inner{
  padding-right:0px!important
}

.delBtn {
  width: 69px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #DDDDDD;
  color: #666;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
}

.top-btns {
  padding: 10px 0;
  display: flex;
  align-items: center;
  font-weight: 600;
  border-bottom: 1px dashed #E5E8ED;
}

.left-btn {
  width: 100px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #333333;
  background-color: #F8F9FA;
  border: 1px dashed #E5E8ED;
  cursor: pointer;
}

.active {
  background: #F66248;
  color: #fff;
}

.left-btn2 {
  margin-left: 10px;
  margin-right: 20px;
  cursor: pointer;
}

.line-line {
  height: 20px;
  width: 1px;
  border-left: 1px dashed #aaa;
  margin-right: 20px;
}

.right-btn1,
.right-btn2 {
  width: 130px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #333333;
  border: 1px dashed #E5E8ED;
  cursor: pointer;
}

.right-btn1 {
  background: rgba(206, 244, 187, 0.26);
  margin-right: 10px;
}

.right-btn2 {
  background: rgba(255, 38, 0, 0.26);
}

.r-box-content {
  width: 100%;
  margin-top: 10px;
}

.content-top {
  display: flex;
  align-items: center;
}
.r-btm{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.r-btm-btn{
  width: 90px;
height: 33px;
font-size: 16px;
line-height: 33px;
text-align: center;
color: #fff;
background: #403F56;
border-radius: 3px;
cursor: pointer;
}
.r-btm-btn2{
border: 1px solid #403F56;
color: #403F56;
background: #fff;
margin-right: 10px;
}
.lamp {
  font-weight: 600;
  display: flex;
  align-items: center;
  border: 1px dashed #E5E8ED;
  background-color: #F8F9FA;
  padding: 4px 20px 4px 10px;
  margin-right: 70px;
}

.num {
  font-weight: 600;
  display: flex;
  align-items: center;
}

.num2 {
  width: 70px;
  margin: 0 10px;
}




/* 按钮动效 */
.pulse-btn {
  position: relative;
  padding: 6px 12px;
  border: none;
  background-color: #4CAF50;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  cursor: pointer;
}

.pulse-container {
  /* 控制动画位置，可根据需求调整 */
  display: inline-block;
  position: relative;
  padding: 10px;
}

.pulse-circle {
  width: 8px;
  height: 8px;
  background-color: #ff6b6b;
  /* 中心圆颜色 */
  border-radius: 50%;
  position: relative;
  z-index: 2;
  /* 保证中心圆在最上层 */
}

/* 扩散动画 */
.pulse-circle::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.4);
  /* 扩散波纹颜色 */
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  animation: pulse 2s infinite;
  /* 2秒循环，可调整速度 */
  z-index: 1;
  /* 波纹在中心圆下层 */
}

/* 关键帧：控制扩散和渐隐 */
@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(3);
    /* 扩散到 3 倍大小 */
    opacity: 0;
  }
}
.title2{
 margin-top: 20px;
 margin-bottom: 10px;
 font-size: 15px;
}
 
.chartWrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

}

.chartBox {
  width: 32.5%;
  background-color: #F8F9FA;
}

.chartTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 33px;
  line-height: 33px;
  color: #999999;
  background: rgba(210, 214, 221, 0.34);
  padding: 10px;
}

/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px; /* 纵向滚动条宽度 */
  height: 8px; /* 横向滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

/* 滚动条滑块悬停效果 */
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 滚动条边角 */
::-webkit-scrollbar-corner {
  background: transparent;
}

/* Firefox 滚动条样式 */
* {
  scrollbar-width: thin; /* 可选: auto | thin | none */
  scrollbar-color: #c1c1c1 #f1f1f1; /* 滑块颜色 轨道颜色 */
}
>>>.el-upload--text{
  display: flex;
  align-items: center;
}
.custom-upload-list{
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.fileWrap{
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  position: relative;
  margin-right: 10px;
}
.fileWrap .closeBtn{
  position: absolute;
  top:-8px;
  right: -8px;
}
.fileWrap .imgs{
  width: 100%;
  height: 100%;
}
.fileWrap .imgs img{
width: 100%;
  height: 100%;
}
.fileWrap .imgs i{
  font-size: 30px;
  font-size: 25px;
  color: #999;
  margin-top: 5px;
}


</style>



// WEBPACK FOOTER //
// src/components/traditionalAndWest/tradiInfo.vue